<template>
    <span v-if="user && user.id" @click="click">
        <span v-if="mode === 'avatar'" class="tooltip-right" :data-tooltip="user.full_name">
            <img class="user-image small" :src="imagepath" width="20" height="20">
        </span>
        <span v-if="mode === 'tiny'" @click="$refs.modal.show()">
            {{ user.full_name }}
        </span>
        <span v-if="mode === 'small'" class="user-small tooltip-bottom" @click="$refs.modal.show()">
            <img class="user-image" :src="imagepath" width="20" height="20">
            <span class="full_name">
                {{ user.full_name }}
            </span>
        </span>
        <span v-if="!mode" class="user">
            <img class="user-image" :src="imagepath" width="50" height="50">
            <span>
                <span class="full_name stack">
                    {{ user.full_name }}
                </span>
                <span class="phone stack">
                    {{ user.phone }}
                </span>
            </span>
        </span>
        <span v-if="mode === 'large'" class="user">
            <img class="user-image" :src="imagepath" width="131" height="131">
            <span>
                <span class="full_name stack">
                    {{ user.full_name }}
                </span>
                <span class="phone stack" @click.stop="openPhoneApp">
                    <i class="fa fa-fw fa-phone"></i> 
                    {{ user.phone }}
                </span>
                <span class="email stack">
                    <i class="fa fa-fw fa-envelope-o"></i> 
                    {{ user.email }}
                </span>
            </span>
        </span>
        
        <picnic-modal :title="user.full_name" ref="modal">
            <span class="user">
                <img class="user-image" :src="imagepath" width="131" height="131">
                <span>
                    <span class="full_name stack">
                        {{ user.full_name }}
                    </span>
                    <span class="phone stack">
                        <i class="fa fa-fw fa-phone"></i> 
                        {{ user.phone }}
                    </span>
                    <span class="email stack">
                        <i class="fa fa-fw fa-envelope-o"></i> 
                        {{ user.email }}
                    </span>
                </span>
            </span>
        </picnic-modal>
    </span>
</template>

<script>
    import config from '../config'
    import PicnicModal from './PicnicModal.vue'

    export default {
        props: [
          'user',
          'mode'
        ],
        components: {
            'picnic-modal': PicnicModal
        },
        computed: {
          imagepath () {
            return this.user.imagepath ?
              `https://${window.STAGING ? 'staging.' : ''}mccluskeybucks.com/useruploads/${this.user.imagepath}` :
              `https://${window.STAGING ? 'staging.' : ''}mccluskeybucks.com/landing-assets/images/defaultuser_teaser.png`
          },
          title () {
            return this.mode == 'small' ? this.user.phone : false
          },
          imageWidth () {
            return this.mode === 'small' ? 20 : 50
          },
        },
        methods: {
            click () {
                this.$emit('click')
            },
            openPhoneApp() {
                document.location.href = "tel:+1" + this.user.phone;
            }
        },
    }
</script>

<style scoped lang="less">
  .user {
    display: flex;
    flex-direction: row;
    width: 500px;
    width: fit-content;
    width: -moz-fit-content;
  }

  .user-image {
    border-radius: 50%;
    margin-right: 0.5em;
    transition: all 1s;
    z-index: 1;
    &.small {
      position: relative;
      bottom: -4px;
    }
  }

  .user-small {
    .user-image {
      display: inline-block;
    }
    .phone {
      display: none;
    }
  }

  .full_name {
    white-space: nowrap;
  }

  .phone {
    white-space: nowrap;
  }

  .email {
    white-space: nowrap;
  }

  .modal {
    // position: absolute;
    // display: inline-block;
    // z-index: 2;
    .user-image {
      border-radius: 20%;
    }
  }
</style>
